export default __webpack_public_path__ + "static/media/vimc-logo.0ddf4fef.png";